const csrfToken = () => {
    const element = document.querySelector('meta[name="csrf_token"]');

    if (!element) {
        return null;
    }

    return element.getAttribute("content");
};

export default csrfToken();
